import api from './api';
import apiRoutes from '../../../api/apiRoutes';

/**
 * Fetch nearby Points of Interest (POIs)
 * around a given location (lat/lng)
 */
export const fetchNearbyPOIs = async (lat, lon, radius = 1000, types = '') => {

  const response = await api.get(apiRoutes.poi.nearProperty, {
    params: {
      lat,
      lon,
      radius,
      ...(types && { types })
    }
  });

  return response.data;
};

/**
 * Fetch POIs by category
 * e.g. schools, hospitals, restaurants, transport
 */
export const fetchPOIsByCategory = async (
  category,
  lat,
  lon,
  radius = 2000
) => {

  const response = await api.get(apiRoutes.poiAdvanced.category, {
    params: {
      category,
      lat,
      lon,
      radius
    }
  });

  return response.data;
};

/**
 * Fetch single POI details
 */
export const fetchPOIById = async (poiId) => {

  const response = await api.get(
    apiRoutes.poi.detail(poiId)
  );

  return response.data;
};

/**
 * Search POIs (text-based + GIS hybrid search)
 */
export const searchPOIs = async (query, lat, lon) => {

  const response = await api.get(apiRoutes.poiAdvanced.search, {
    params: {
      q: query,
      lat,
      lon
    }
  });

  return response.data;
};

/**
 * Get POI clusters (for map visualization)
 * useful for heatmaps / clustering layers
 */
export const fetchPOIClusters = async (bounds) => {

  const response = await api.get(apiRoutes.poiAdvanced.clusters, {
    params: {
      north: bounds.north,
      south: bounds.south,
      east: bounds.east,
      west: bounds.west
    }
  });

  return response.data;
};

/**
 * Get AI-ranked POIs for a property
 * (schools, safety, lifestyle scoring)
 */
export const fetchSmartPOIRecommendations = async (propertyId) => {

  const response = await api.get(
    apiRoutes.poiAdvanced.recommendations(propertyId)
  );

  return response.data;
};
